import { CircularProgressbar } from 'react-circular-progressbar';
import { proAccountThemeCoreUI } from '@orcha/micro-library-core-ui';

export type CircularProgressBarScoreProps = {
  value: number;
};

/**
 * CircularProgressBarScore component from [MicroLibraryAppDetailsUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryAppDetailsUI)
 * @param {CircularProgressBarScoreProps} circularProgressBarScoreProps - The props for the CircularProgressBarScore component
 * @returns {ReactElement} The CircularProgressBarScore component
 */

export const CircularProgressBarScore = ({
  value,
}: CircularProgressBarScoreProps) => {
  const getColorForScore = (score: number) => {
    if (score >= 65) {
      return proAccountThemeCoreUI.palette.success.light;
    }
    if (score < 65 && score >= 46) {
      return proAccountThemeCoreUI.palette.warning.main;
    }
    return proAccountThemeCoreUI.palette.error.main;
  };

  return (
    <CircularProgressbar
      value={value}
      text={`${value}%`}
      strokeWidth={7}
      styles={{
        root: {
          verticalAlign: 'middle',
        },
        path: {
          // Path color
          stroke: `${getColorForScore(value)}`,
          // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
          strokeLinecap: 'round',
          // Customize transition animation
          transition: 'stroke-dashoffset 0.5s ease 0s',
        },
        // Customize the circle behind the path, i.e. the "total progress"
        trail: {
          // Trail color
          stroke: '#E8EAEC',
          /* Used when trail is not full diameter, i.e. when props.circleRatio is set */
          strokeLinecap: 'round',
        },
        // Customize the text
        text: {
          // Text color
          fill: proAccountThemeCoreUI.palette.text.primary,
          // Text size
          fontSize: '26px',
          fontWeight: 700,
          fontFamily: proAccountThemeCoreUI.typography.fontFamily,
          dominantBaseline: 'central',
          textAnchor: 'middle',
        },
      }}
    />
  );
};
